<template>
    <div class="my-button" :class="[{ 'disabled': isDisabled },'th-button ' + this.divClass]" @click="handleClick" v-html="buttonText"></div>
</template>

<script>

export default {
  name: 'XrButton',
  props: {
    type: String,
    disabled: { // 是否可被点击
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      divClass: '',
      buttonText: '',
      isDisabled: this.disabled,      //是否可被点击
    }
  },
  watch: {
    disabled(newVal) {
      this.isDisabled = newVal;
    },
    type(newVal) {
      this.divClass = 'th-button ' + newVal;
    }
  },
  created(){
    this.buttonText = this.$slots.default[0].text;
    this.divClass = this.type;
  },
  methods: {
    // 如果状态为不可以 则不触发点击事件
    handleClick() {
      if (!this.isDisabled) {
        this.$emit('click');
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  /** 按钮样式 */
  .th-button{
    display: inline;
    border: 1px solid #d9d9d9;
    padding: 4px 10px;
    border-radius: 5px;
    font-size: 12px;
    cursor: pointer;
    color: rgba(0,0,0,.65);
    margin-right: 8px;
  }

  .primary{
    background: #007aff;
    color: #fff;
  }
  .primary:hover{
    background: #007aff;
    color: #fff;
  }

  .error{
    background: red;
    color: #fff;
  }
  .error:hover{
    background: red;
    color: #fff;
  }

  .default{
    background: #d9d9d9;
  }
  .default:hover{
    background: #d9d9d9;
  }

  .my-button.disabled {
    /* 设置禁用时的样式 */
    opacity: 0.5; /* 添加透明度 */
    cursor: not-allowed; /* 显示禁止标志 */
  }

</style>



// WEBPACK FOOTER //
// src/components/XrButton/index.vue